import React from 'react';
import { createPortal } from 'react-dom';
import { X, Calendar, ArrowRight } from 'lucide-react';
import { Scenario } from '../../interface/ReasearchData';
interface ScenarioHistoryProps {
  isOpen: boolean;
  onClose: () => void;
  scenarioSets: Scenario[];
  onSelectScenarioSet: (scenarioSet: Scenario) => void;
}
export function ScenarioHistory({
  isOpen,
  onClose,
  scenarioSets,
  onSelectScenarioSet
}: ScenarioHistoryProps) {
  if (!isOpen) return null;
  return createPortal(
    <div className="fixed inset-0 z-[9999] flex justify-end">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      {/* Panel */}
      <div className="relative h-full w-full max-w-md bg-theme-secondary shadow-lg animate-slideIn overflow-hidden flex flex-col border-l border-theme-tertiary">
        <div className="p-4 border-b border-theme-tertiary flex justify-between items-center">
          <h2 className="text-lg font-medium text-theme-primary">
            Recent Scenarios
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-theme-tertiary transition-colors">
            <X size={18} className="text-theme-muted hover:text-theme-primary" />
          </button>
        </div>
        <div className="overflow-y-auto flex-grow p-4 scrollbar-hide">
          <div className="space-y-4">
            {scenarioSets.map(scenarioSet => <div key={scenarioSet.id} className="bg-theme-tertiary rounded-lg p-4 border border-theme-tertiary hover:border-theme-tertiary/70 transition-colors">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="text-theme-primary font-medium">
                      {scenarioSet.name}
                    </h3>
                    <div className="flex items-center text-xs text-theme-muted mt-1">
                      <Calendar size={12} className="mr-1" />
                      {scenarioSet.timestamp}
                    </div>
                  </div>
                  <button onClick={() => onSelectScenarioSet(scenarioSet)} className="p-1 bg-blue-600/20 rounded-full text-blue-400 hover:bg-blue-600/40 transition-colors">
                    <ArrowRight size={14} />
                  </button>
                </div>
                {/* <div className="grid grid-cols-3 gap-2 text-xs">
                  <ScenarioHistoryItem title="Bull" color="green" revenue={formatLargeNumber(scenarioSet.bull.revenue['2025'])} threeYearPrice={scenarioSet.bull.sharePriceHigh['2027']} fiveYearPrice={scenarioSet.bull.sharePriceHigh['2029']} />
                  <ScenarioHistoryItem title="Base" color="blue" revenue={formatLargeNumber(scenarioSet.base.revenue['2025'])} threeYearPrice={scenarioSet.base.sharePriceHigh['2027']} fiveYearPrice={scenarioSet.base.sharePriceHigh['2029']} />
                  <ScenarioHistoryItem title="Bear" color="red" revenue={formatLargeNumber(scenarioSet.bear.revenue['2025'])} threeYearPrice={scenarioSet.bear.sharePriceHigh['2027']} fiveYearPrice={scenarioSet.bear.sharePriceHigh['2029']} />
                </div> */}
              </div>)}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
interface ScenarioHistoryItemProps {
  title: string;
  color: string;
  revenue: string;
  threeYearPrice: string;
  fiveYearPrice: string;
}
function ScenarioHistoryItem({
  title,
  color,
  revenue,
  threeYearPrice,
  fiveYearPrice
}: ScenarioHistoryItemProps) {
  return <div className={`bg-${color}-900/20 p-2 rounded border border-${color}-800/30`}>
      <div className={`text-${color}-400 font-medium mb-1`}>{title}</div>
      <div>
        <div className="text-theme-muted">Rev</div>
        <div className="text-theme-primary">${revenue}</div>
      </div>
      <div className="mt-1 pt-1 border-t border-theme-tertiary/30 grid grid-cols-2 gap-1">
        <div>
          <div className="text-theme-muted text-[10px]">3Y Price</div>
          <div className={`text-${color}-400`}>${threeYearPrice || '0'}</div>
        </div>
        <div>
          <div className="text-theme-muted text-[10px]">5Y Price</div>
          <div className={`text-${color}-400`}>${fiveYearPrice || '0'}</div>
        </div>
      </div>
    </div>;
}
function formatLargeNumber(value: string): string {
  const num = parseFloat(value.replace(/,/g, ''));
  if (isNaN(num)) return '0';
  if (num >= 1e9) {
    return (num / 1e9).toFixed(1) + 'B';
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(1) + 'M';
  } else {
    return num.toLocaleString();
  }
}